var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehousing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 56,
    viewBox: "0 0 47 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9085 11.5803L23.0296 0.760484C22.7979 0.591223 22.5185 0.5 22.2316 0.5C21.9446 0.5 21.6652 0.591223 21.4335 0.760484L6.55458 11.5803C6.38226 11.7063 6.24218 11.8711 6.1458 12.0616C6.04941 12.252 5.99945 12.4625 6 12.6759V31.6106C6 31.9693 6.14251 32.3133 6.39618 32.567C6.64985 32.8206 6.99389 32.9631 7.35263 32.9631H11.4105V20.7908C11.4105 20.4321 11.553 20.088 11.8067 19.8344C12.0604 19.5808 12.4044 19.4383 12.7631 19.4383H31.7C32.0587 19.4383 32.4027 19.5808 32.6564 19.8344C32.9101 20.088 33.0526 20.4321 33.0526 20.7908V32.9631H37.1105C37.4692 32.9631 37.8133 32.8206 38.0669 32.567C38.3206 32.3133 38.4631 31.9693 38.4631 31.6106V12.6759C38.4637 12.4625 38.4137 12.252 38.3173 12.0616C38.2209 11.8711 38.0808 11.7063 37.9085 11.5803Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9085 11.5803L23.0296 0.760484C22.7979 0.591223 22.5185 0.5 22.2316 0.5C21.9446 0.5 21.6652 0.591223 21.4335 0.760484L6.55458 11.5803C6.38226 11.7063 6.24218 11.8711 6.1458 12.0616C6.04941 12.252 5.99945 12.4625 6 12.6759V31.6106C6 31.9693 6.14251 32.3133 6.39618 32.567C6.64985 32.8206 6.99389 32.9631 7.35263 32.9631H11.4105V20.7908C11.4105 20.4321 11.553 20.088 11.8067 19.8344C12.0604 19.5808 12.4044 19.4383 12.7631 19.4383H31.7C32.0587 19.4383 32.4027 19.5808 32.6564 19.8344C32.9101 20.088 33.0526 20.4321 33.0526 20.7908V32.9631H37.1105C37.4692 32.9631 37.8133 32.8206 38.0669 32.567C38.3206 32.3133 38.4631 31.9693 38.4631 31.6106V12.6759C38.4637 12.4625 38.4137 12.252 38.3173 12.0616C38.2209 11.8711 38.0808 11.7063 37.9085 11.5803Z",
    fill: "url(#paint0_linear_245_93626)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5265 14.0282H24.937C25.2957 14.0282 25.6398 13.8857 25.8934 13.6321C26.1471 13.3784 26.2896 13.0344 26.2896 12.6757C26.2896 12.317 26.1471 11.973 25.8934 11.7194C25.6398 11.4657 25.2957 11.3232 24.937 11.3232H19.5265C19.1677 11.3232 18.8237 11.4657 18.57 11.7194C18.3163 11.973 18.1738 12.317 18.1738 12.6757C18.1738 13.0344 18.3163 13.3784 18.57 13.6321C18.8237 13.8857 19.1677 14.0282 19.5265 14.0282Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5752 24.3058C13.5752 23.1105 14.5441 22.1416 15.7394 22.1416H27.6425C28.8378 22.1416 29.8067 23.1105 29.8067 24.3058C29.8067 25.5011 28.8378 26.47 27.6425 26.47H15.7394C14.5441 26.47 13.5752 25.5011 13.5752 24.3058Z",
    fill: "#FFB326"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5752 30.799C13.5752 29.6037 14.5441 28.6348 15.7394 28.6348H27.6425C28.8378 28.6348 29.8067 29.6037 29.8067 30.799C29.8067 31.9942 28.8378 32.9632 27.6425 32.9632H15.7394C14.5441 32.9632 13.5752 31.9942 13.5752 30.799Z",
    fill: "#FFB326"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_245_93626)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_245_93626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4325 35.8515V22.0046C24.3518 21.4403 24.4036 20.8649 24.5838 20.3241C24.764 19.7832 25.0677 19.2918 25.4707 18.8887C25.8738 18.4856 26.3653 18.1819 26.9061 18.0017C27.4469 17.8215 28.0223 17.7697 28.5866 17.8505H42.4335C42.9978 17.7697 43.5732 17.8215 44.114 18.0017C44.6548 18.1819 45.1463 18.4856 45.5494 18.8887C45.9525 19.2918 46.2561 19.7832 46.4363 20.3241C46.6165 20.8649 46.6683 21.4403 46.5876 22.0046V35.8515C46.6683 36.4158 46.6165 36.9912 46.4363 37.532C46.2561 38.0728 45.9525 38.5642 45.5494 38.9673C45.1463 39.3704 44.6548 39.6741 44.114 39.8543C43.5732 40.0345 42.9978 40.0863 42.4335 40.0056H28.5866C28.0223 40.0863 27.4469 40.0345 26.9061 39.8543C26.3653 39.6741 25.8738 39.3704 25.4707 38.9673C25.0677 38.5642 24.764 38.0728 24.5838 37.532C24.4036 36.9912 24.3518 36.4158 24.4325 35.8515Z",
    fill: "#FF900E",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1865 17.8506V26.7126L35.5098 24.4971L38.833 26.7126V17.8506",
    fill: "#FFD74A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3526 35.205H41.7631C42.1219 35.205 42.4659 35.0625 42.7196 34.8088C42.9733 34.5552 43.1158 34.2112 43.1158 33.8525C43.1158 33.4938 42.9733 33.1498 42.7196 32.8961C42.4659 32.6425 42.1219 32.5 41.7631 32.5H29.3526C28.9939 32.5 28.6498 32.6425 28.3962 32.8961C28.1425 33.1498 28 33.4938 28 33.8525C28 34.2112 28.1425 34.5552 28.3962 34.8088C28.6498 35.0625 28.9939 35.205 29.3526 35.205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_245_93626",
    x: 0.305508,
    y: 9.12348,
    width: 46.3195,
    height: 46.2095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -12.1,
    dy: 3.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.995
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_245_93626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_245_93626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_245_93626",
    x: 6.79551,
    y: 0.213476,
    width: 57.4295,
    height: 57.4295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_245_93626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_245_93626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_93626",
    x1: 22.2315,
    y1: -54.8969,
    x2: 24.0871,
    y2: 44.2808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehousing);
export default __webpack_public_path__ + "static/media/Warehousing.77d708bc69ec9087556f5ce7a3e86aac.svg";
export { ForwardRef as ReactComponent };